export const _showInviteRequestDialog = () => ({
	type: 'UI_SITE_INVITE_REQUEST_DIALOG_SHOW',
})

export const _hideInviteRequestDialog = () => ({
	type: 'UI_SITE_INVITE_REQUEST_DIALOG_HIDE',
})
